import { styled } from '@material-ui/core/styles';

export const HelloMessage = styled('div')(({ theme }) => ({
  width: '100vw',
  paddingLeft: '50px',
  color: theme.colors.gray,
  fontSize: theme.font.sizes.xsmall,
}));
